// extracted by mini-css-extract-plugin
var _1 = "ActionBoxStyle-module__box___ULAzi";
var _2 = "ActionBoxStyle-module__box-action___m9Vr_";
var _3 = "ActionBoxStyle-module__box-active___FeZdf";
var _4 = "ActionBoxStyle-module__box-details___oejcj";
var _5 = "ActionBoxStyle-module__box-requested___KHUDF";
var _6 = "ActionBoxStyle-module__box-action___m9Vr_";
var _7 = "ActionBoxStyle-module__box-active___FeZdf";
var _8 = "ActionBoxStyle-module__box-details___oejcj";
var _9 = "ActionBoxStyle-module__box-requested___KHUDF";
var _a = "ActionBoxStyle-module__edit-btn___Z2cqn";
var _b = "ActionBoxStyle-module__edit-btn___Z2cqn";
var _c = "ActionBoxStyle-module__first___dxM94";
var _d = "ActionBoxStyle-module__label-reversed___RKqEJ";
var _e = "ActionBoxStyle-module__label-reversed___RKqEJ";
var _f = "ActionBoxStyle-module__mr10___jhuo2";
export { _1 as "box", _2 as "box-action", _3 as "box-active", _4 as "box-details", _5 as "box-requested", _6 as "boxAction", _7 as "boxActive", _8 as "boxDetails", _9 as "boxRequested", _a as "edit-btn", _b as "editBtn", _c as "first", _d as "label-reversed", _e as "labelReversed", _f as "mr10" }
